import React, { useState, useEffect, useMemo } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import api from '../../../services/api';
import DataTable from '../../../components/ui/DataTable';
import { dateFilterColumn } from '../../../utils/dateFilterColumn';

const Wrap = styled.div`
  padding: 4px 0 24px;
`;

// Read-only view of the offboarding's materialized task list. OdTask has no
// standalone page/hook, so we fetch it directly here.
export default function OffboardingTasksTab({ offboardingId }) {
  const { t, i18n } = useTranslation();
  const lang = i18n.language;
  const [rows, setRows] = useState([]);
  const [fetching, setFetching] = useState(true);

  useEffect(() => {
    let active = true;
    setFetching(true);
    api.get(`/v1/offboarding-tasks?offboardingId[eq]=${offboardingId}&pageSize=200&pageNumber=1`)
      .then((res) => {
        const r = res.data?.data;
        const items = Array.isArray(r) ? r : (r?.data || []);
        if (active) setRows(items);
      })
      .finally(() => { if (active) setFetching(false); });
    return () => { active = false; };
  }, [offboardingId]);

  const columns = useMemo(() => {
    const statusLabel = (s) => t(`offboarding.task.status.${s}`, { defaultValue: s });
    const ownerLabel = (s) => t(`offboarding.task.owner.${s}`, { defaultValue: s });
    const yesNo = (v) => (v ? t('common.yes', { defaultValue: 'Evet' }) : t('common.no', { defaultValue: 'Hayır' }));
    return [
      { name: 'id', label: 'ID', options: { filter: false, sort: false, display: 'excluded' } },
      { name: 'title', label: t('offboarding.task.title'), options: { filter: false, sort: true } },
      {
        name: 'ownerRole',
        label: t('offboarding.task.ownerRole'),
        options: { filter: false, sort: true, customBodyRender: (v) => ownerLabel(v) },
      },
      {
        name: 'status',
        label: t('offboarding.task.statusLabel'),
        options: { filter: false, sort: true, customBodyRender: (v) => statusLabel(v) },
      },
      {
        name: 'isMandatory',
        label: t('offboarding.task.isMandatory'),
        options: { filter: false, sort: true, customBodyRender: (v) => yesNo(v) },
      },
      dateFilterColumn('slaDueAt', t('offboarding.task.slaDueAt'), lang),
      dateFilterColumn('completedAt', t('offboarding.task.completedAt'), lang),
    ];
  }, [t, lang]);

  return (
    <Wrap>
      <DataTable
        title={t('offboarding.detail.tab.tasks')}
        fetching={fetching}
        columns={columns}
        data={rows}
        totalRowCount={rows.length}
        pageSize={50}
        pageIndex={0}
        disableFilters
      />
    </Wrap>
  );
}
